import { DialogTitle, styled } from '@mui/material';
import { CoreBox } from '@youscience/core';
import { Swiper } from 'swiper/react';

export const sxStyles = {
  dialogHeader: {
    display: 'flex',
    gap: '1rem',
    padding: '1.5rem',
    alignSelf: 'stretch',
    alignItems: 'center',
  },
  dialogTitle: {
    display: 'flex',
    flex: '1 0 0',
  },
  dialogTitleButtons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.5rem',
  },
  dialogTitleButton: {
    display: 'flex',
    padding: '0.5rem 1rem',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',
  },
  dialogMain: {
    display: 'flex',
    padding: '4rem',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  dialogContent: {
    display: 'flex',
    maxWidth: '49.75rem',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '2.5rem',
  },
  dialogContentTitle: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  dialogContentPdf: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    alignSelf: 'stretch',
  },
  dialogContentPdfControls: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.75rem',
    alignSelf: 'stretch',
  },
  dialogContentAgreement: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '0.5rem',
    alignSelf: 'stretch',
    padding: '0.5rem 0',
  },
  dialogContentSignature: {
    display: 'flex',
    flex: '1 0 0',
    alignItems: 'flex-start',
    gap: '1.5rem',
    alignSelf: 'stretch',
  },
  dialogFooter: {
    display: 'flex',
    padding: '1.5rem',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '0.5rem',
    alignSelf: 'stretch',
  },
  link: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
};

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  padding: '0',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,
}));

export const StyledPdf = styled(CoreBox, { shouldForwardProp: (prop) => prop !== 'isLoading' })<{
  isLoading: boolean;
}>(({ isLoading, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  alignSelf: 'center',
  border: isLoading ? 'none' : `1px solid ${theme.palette.grey[300]}`,
  '>': { overflowAnchor: 'none !important' },
}));

export const StyledSwiper = styled(Swiper)(({ theme }) => ({
  width: '100%',

  'swiper-pagination': {
    display: 'flex',
    justifyContent: 'center',
    gap: '1rem',
  },

  '.swiper-pagination-bullet': {
    background: theme.palette.common.white,
    width: '12px',
    height: '12px',
    border: `1px solid ${theme.palette.primary.dark}`,
    opacity: '1',
  },

  '.swiper-pagination-bullet-active': {
    background: theme.palette.primary.dark,
  },

  '.swiper-slide': {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '2rem',

    '& > div:first-of-type': {
      boxSizing: 'border-box',
    },

    [theme.breakpoints.up('xs')]: {
      justifyContent: 'start',
    },
  },
}));
